import axios from 'axios';
import config from '../../../../../core/config/configureSettings';
import { constructServiceURL } from '../../../../../core/modules/common/tools/URLTools';

const apiFetchMrdXmlDailyAnalysis = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'getMrdXmlDailyAnalysis',
    stub: config.useStubbedEndpoints,
  });

  return axios.post(serviceURL, payload, {
    cancelToken: payload.token,
  });
};

export default apiFetchMrdXmlDailyAnalysis;
